import { useGenericSetRanking } from '@infuse/iam/role/mutations';
import { setTenantRoleRanking } from '@infuse/api/iam/tenant';

export const useSetTenantRoleRanking = () => {
  return useGenericSetRanking({
    apiFn: setTenantRoleRanking
  });
};
